import {FormType} from '../../../../../blocks/FormBlock'
import {copy} from '../../../../../../util/fieldscopy'

const companyVat: FormType = {
	id: 17,
	parent_id: 0,
	channel: 'input',
	name: 'ondernemingsnummer',
	label: copy?.company || 'Ondernemingsnr',
	required: false,
	type: 'text',
	placeholder: '0123.456.789'
}

export default companyVat
